// packages/react/use-layout-effect/src/useLayoutEffect.tsx
import * as React from "react";
var useLayoutEffect2 = Boolean(globalThis?.document) ? React.useLayoutEffect : () => {
};
export {
  useLayoutEffect2 as useLayoutEffect
};
//# sourceMappingURL=index.mjs.map
